import gql from 'graphql-tag';

const query = gql`
  query BloodSugarMeasurements {
    diabetes {
      userDiabetes {
        treatment {
          optimalBloodSugarTarget {
            min {
              value
              unit
            }
            max {
              value
              unit
            }
          }
        }
      }
      bloodSugarMeasurements {
        userMeasurements(first: 1) {
          edges {
            node {
              id
              value {
                value
                unit
              }
              valueLabel
              date
              type
              mealType
            }
          }
        }
      }
    }
  }
`;

export default query;
